<template>
    <a :href="'/projects/accept/'+project_id" class="btn btn-success text-nowrap">Accept Quote</a>
</template>

<script>
export default {
  props: ['project_id']
}
</script>
